import { transformPromptDtoToModel } from '../prompt/mappers';
import { SearchResponse, SearchResponseDto } from './types';

export const transformPromptsDtoToCards = (response: SearchResponseDto): SearchResponse => {
    return response.map(transformPromptDtoToModel);
};
